import { DOT_PHRASE_SUGGESTION_LIMIT, DOT_PHRASE_TRIGGER_PREFIX } from "../constants/dot-phrases";
import { InsertableDotPhrase } from "../types/insertable-dot-phrase";

import { normalizeDotPhraseSearch } from "./dot-phrases";

export function matchDotPhrases(
  dotPhrases: InsertableDotPhrase[],
  query: string,
): InsertableDotPhrase[] {
  const term = normalizeDotPhraseSearch(query).toLowerCase();

  return dotPhrases
    .filter(({ trigger }) =>
      trigger.slice(DOT_PHRASE_TRIGGER_PREFIX.length).toLowerCase().startsWith(term),
    )
    .slice(0, DOT_PHRASE_SUGGESTION_LIMIT);
}
